import react_image from '../assets/img/skills/react.png';
import node_image from '../assets/img/skills/node.png';
import javascript_image from '../assets/img/skills/javascript.png';
import html_image from '../assets/img/skills/html.png';
import dot_net_image from '../assets/img/skills/Microsoft-Dotnet.png';
import css_image from '../assets/img/skills/CSS.png';
import c_sharp_image from '../assets/img/skills/C-Sharp.png';
import angular_shield_image from '../assets/img/skills/AngularJS-Shield.svg';

const skills = [
  { 
    name: "Angular JS",
    width: '170px',
    image: angular_shield_image,
    height: '100px'
  },
  { 
    name: "JavaScript",
    width: '170px',
    image: javascript_image,
    height: '100px'
  },
  { 
    name: "HTML", 
    image: html_image,
    width: '100px',
    height: '100px'
  },
  { 
    name: "CSS", 
    image: css_image,
    width: '120px',
    height: '100px'
  },
  { name: "React.js",
    image: react_image,
    width: '100px',
    height: '100px'
  },
  { 
    name: "Node.js", 
    image: node_image,
    width: '170px',
    height: '100px'
  },
  { 
    name: "MS .NET", 
    image: dot_net_image,
    width: '120px',
    height: '100px'
  },
  { 
    name: "C#", 
    image: c_sharp_image,
    width: '120px',
    height: '100px'
  },
  // { 
  //   name: "Software Architecture", 
  // },
  // { 
  //   name: "OOP", 
  // }
];

export default skills;
